module.exports = __webpack_public_path__ + "img/rollie-small.84893001.svg";